const FREE_MAX_PROJECT_COUNT = 1;

export const CheckEquity = ({ userData, type, projectCount }) => {
  // const { storageRemaining, transcriptRemaining, aiDubbingRemaining, level } =
  //   userData.userSubscription;
  // switch (type) {
  //   case 'storage':
  //     return storageRemaining > 0;
  //   case 'transcript':
  //     return transcriptRemaining > 0;
  //   case 'word':
  //     return aiDubbingRemaining > 0;
  //   case 'level':
  //     return level > 0;
  //   case 'freeCount':
  //     return level > 1 || (level === 1 && projectCount < FREE_MAX_PROJECT_COUNT);
  //   default:
  //     return true;
  // }
  return true;
};
